/**
 * CUSTOM.JS - Custom Script File
 * --------------------------------
 * ⚠️ Ensure this script is connected to the storefront.
 * To enable it, uncomment the <script> tag linking to this file in theme.liquid.
 * 
 * Example:
 * <!-- <script type="module" src="{{ 'custom.js' | asset_url }}"></script> --> ← Uncomment this line
 */

const blockIds = [
  'AeWpWTUlEaTA5WVJxU__afterpay_on_site_messaging_payments_messaging_GheLWR',
  'AQnFEbUVGZVhTUVI2c__afterpay_on_site_messaging_payments_messaging_crKnbB',
];

function applyStyles(blockId) {
  const shadowHost = document.querySelector('#placement-' + blockId);
  const shadowRoot = shadowHost?.shadowRoot;
  const outerBlock = document.querySelector(`[data-block-id^="${blockId}"]`);

  if (shadowRoot && outerBlock) {
    const logo = shadowRoot.querySelector('.afterpay-logo.brand-afterpay');
    const svg = shadowRoot.querySelector('.afterpay-logo-link .afterpay-logo svg');

    if (logo && svg) {
      svg.setAttribute('width', '70');
      svg.style.setProperty('width', '70px');
      logo.style.setProperty('width', 'auto');
      logo.style.setProperty('min-width', '0');
      logo.style.setProperty('min-height', '0');
      outerBlock.style.setProperty('margin-top', '0');
      outerBlock.style.setProperty('margin-bottom', '0');
      return true;
    }
  }
  return false;
}

function waitForBlocks() {
  let remaining = new Set(blockIds);

  // Try applying immediately for any already present blocks
  for (const blockId of blockIds) {
    if (applyStyles(blockId)) {
      remaining.delete(blockId);
    }
  }

  if (remaining.size === 0) return; // All done

  // Watch for new nodes added to DOM
  const observer = new MutationObserver(() => {
    for (const blockId of remaining) {
      if (applyStyles(blockId)) {
        remaining.delete(blockId);
      }
    }
    if (remaining.size === 0) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForBlocks);
} else {
  waitForBlocks();
}

// Hide asterisks from Easify product options placeholders
const hideAsterisks = () => {
  document.querySelectorAll('.easify-product-options [placeholder]').forEach(el => {
    const original = el.getAttribute('placeholder');
    const cleaned = original.replace(/\s?\*+$/, '');
    if (original !== cleaned) {
      el.setAttribute('placeholder', cleaned);
    }
  });
};

// Run once on load
hideAsterisks();

// Observe Easify container for dynamic changes
const easifyContainer = document.querySelector('.easify-product-options');
if (easifyContainer) {
  const observer = new MutationObserver(() => {
    hideAsterisks();
  });
  observer.observe(easifyContainer, { childList: true, subtree: true });
}

// Sticky Add to Cart Button Validation Sync with main ATC button
let currentForm = null;
let rafId = null;

function syncStickyButton() {
  const form = document.querySelector('[tpo-validated-form]');
  // Use a more robust selector that doesn't rely on the custom class 'tpo_sticky-atc'
  // which might be lost during re-renders.
  const stickyButton = document.querySelector('product-sticky-bar button[type="submit"]');
  
  if (!form || !stickyButton) return;
  
  const isInvalid = form.getAttribute('tpo-validated-form') === 'false';
  
  // Performance optimization: Only write to DOM if state actually changes
  if (isInvalid) {
    if (!stickyButton.disabled) {
      stickyButton.style.pointerEvents = 'none';
      stickyButton.style.opacity = '0.5';
      stickyButton.disabled = true;
    }
  } else {
    if (stickyButton.disabled) {
      stickyButton.style.pointerEvents = '';
      stickyButton.style.opacity = '';
      stickyButton.disabled = false;
    }
  }
}

const formObserver = new MutationObserver(() => {
  syncStickyButton();
});

function updateFormObserver() {
  const form = document.querySelector('[tpo-validated-form]');
  
  // If the form has changed (or is new), update the observer
  if (form && form !== currentForm) {
    if (currentForm) {
      formObserver.disconnect();
    }
    formObserver.observe(form, { attributes: true, attributeFilter: ['tpo-validated-form'] });
    currentForm = form;
    syncStickyButton();
  } else if (!form && currentForm) {
    // Form disappeared
    currentForm = null;
    formObserver.disconnect();
  }
}

const bodyObserver = new MutationObserver(() => {
  // Performance optimization: Debounce using requestAnimationFrame
  if (rafId) return;
  
  rafId = requestAnimationFrame(() => {
    updateFormObserver();
    syncStickyButton();
    rafId = null;
  });
});

bodyObserver.observe(document.body, { childList: true, subtree: true });

// Initial check
updateFormObserver();

// =============================================================================
// Variant image carousel — preserve scroll position across variant re-renders
// + auto-advance when clicking/tapping a cell at the visible edge
// =============================================================================
// When a swatch is selected, VariantPicker fetches fresh section HTML and calls
// replaceWith() on the variant-picker block, tearing down and rebuilding the
// scroll-carousel element from scratch (connectedCallback resets scrollLeft to
// 0). This IIFE handles two things:
//
//  1. Auto-advance: if the tapped cell is within half its width of the visible
//     edge, scroll forward/back by one cell after the re-render completes.
//     Scrolled on the NEW element (not old) so the animation can never be
//     killed mid-flight by replaceWith(). scrollLeft is NOT modified during
//     mousedown, which would physically move the label under the cursor and
//     prevent the click event from firing.
//
//  2. Preserve position: save every carousel's scrollLeft before the re-render,
//     restore after the new DOM is inserted. On restore, call
//     carousel.select(closestIndex, {instant:true}) to sync the theme's internal
//     _targetIndex2 (preventing ResizeObserver from snapping back to 0), then
//     immediately override scrollLeft to the saved value. For edge-clicked
//     carousels, restore to the pre-click position first, then smooth-advance.
(function () {
  const saved = new Map(); // carousel id → { scrollLeft, advanceTarget: number|null }
  let recentTouch = false; // true briefly after touchstart to suppress synthetic mousedown

  function closestSnapIndex(carousel, scrollLeft) {
    const cells = carousel.cells;
    return cells.reduce(function (best, cell, i) {
      return Math.abs(cell.offsetLeft - scrollLeft) <
             Math.abs(cells[best].offsetLeft - scrollLeft) ? i : best;
    }, 0);
  }

  function onPointerDown(event) {
    if (event.type === 'touchstart') {
      recentTouch = true;
    } else {
      // mousedown — skip advance entirely if triggered by a touch interaction
      if (recentTouch) return;
    }

    const cell = event.target.closest('.variant-picker__swatch-carousel .thumbnail-swatch');
    if (!cell) return;
    const carousel = cell.closest('.variant-picker__swatch-carousel');
    if (!carousel?.id) return;
    const cells = carousel.cells;
    if (!cells.length) return;

    // Auto-advance is desktop (real mouse) only — touch devices use native swipe.
    const snapIdx = closestSnapIndex(carousel, carousel.scrollLeft);
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;
    let advanceTarget = null;
    if (event.type === 'mousedown') {
      const cr = carousel.getBoundingClientRect();
      const cellRect = cell.getBoundingClientRect();
      const halfWidth = cellRect.width / 2;
      if (cellRect.right > cr.right - halfWidth && snapIdx < cells.length - 1) {
        advanceTarget = Math.min(maxScroll, cells[snapIdx + 1].offsetLeft);
      } else if (cellRect.left < cr.left + halfWidth && snapIdx > 0) {
        advanceTarget = Math.max(0, cells[snapIdx - 1].offsetLeft);
      }
    }

    // Save all carousels — do NOT change scrollLeft here so the click fires normally
    document.querySelectorAll('.variant-picker__swatch-carousel[id]').forEach(function (c) {
      saved.set(c.id, {
        scrollLeft: c.scrollLeft,
        advanceTarget: c === carousel ? advanceTarget : null
      });
    });
  }

  // Clear recentTouch after the touch-triggered synthetic mousedown has fired (~300 ms)
  document.addEventListener('touchend', function () {
    setTimeout(function () { recentTouch = false; }, 350);
  }, true);

  document.addEventListener('touchstart', onPointerDown, { capture: true, passive: true });
  document.addEventListener('mousedown', onPointerDown, true);

  new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        const carousels = node.classList?.contains('variant-picker__swatch-carousel')
          ? [node]
          : Array.from(node.querySelectorAll('.variant-picker__swatch-carousel'));
        if (!carousels.length) continue;

        // Pass 1: restore scroll positions for carousels that were saved.
        for (const carousel of carousels) {
          if (!carousel.id || !saved.has(carousel.id)) continue;
          const { scrollLeft, advanceTarget } = saved.get(carousel.id);
          saved.delete(carousel.id);

          if (advanceTarget !== null && advanceTarget !== scrollLeft) {
            carousel.select(closestSnapIndex(carousel, advanceTarget), { instant: true });
            carousel.scrollLeft = scrollLeft;
            requestAnimationFrame(function () {
              carousel.scrollTo({ left: advanceTarget, behavior: 'smooth' });
            });
          } else if (scrollLeft > 0) {
            carousel.select(closestSnapIndex(carousel, scrollLeft), { instant: true });
            carousel.scrollLeft = scrollLeft;
          }
        }

        // Pass 2: auto-correct — if the checked input's label is hidden (the
        // selected design doesn't exist for the new option combo), find and
        // activate the first visible, enabled input directly. We defer via rAF
        // so the DOM is fully settled, and dispatch 'change' directly on the
        // input (rather than label.click) so VariantPicker's delegate reliably
        // picks it up. Matches both thumbnail-swatch and block-swatch labels.
        for (const carousel of carousels) {
          const checkedInput = carousel.querySelector('input[data-option-position]:checked');
          if (!checkedInput) continue;
          const checkedLabel = carousel.querySelector('label[for="' + checkedInput.id + '"]');
          if (!checkedLabel || !checkedLabel.hasAttribute('hidden')) continue;
          // Selection is hidden — find the first input whose label is visible.
          const firstValidInput = Array.from(carousel.querySelectorAll('input[data-option-position]:not([disabled])'))
            .find(function (inp) {
              const lbl = carousel.querySelector('label[for="' + inp.id + '"]');
              return lbl && !lbl.hasAttribute('hidden');
            });
          if (!firstValidInput) continue;
          requestAnimationFrame(function () {
            firstValidInput.checked = true;
            firstValidInput.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}());

// =============================================================================
// Easify Product Options — Loading Placeholder
// =============================================================================
// The placeholder HTML is server-rendered in snippets/product-info.liquid so it
// is present on first paint. This script only removes it once Easify loads,
// or after a timeout if Easify never fires.
(function () {
  // Fading hide — used only for the timeout fallback path.
  function hideLoader(loader) {
    loader.classList.add('is-hidden');
    loader.addEventListener('transitionend', function () {
      loader.remove();
    }, { once: true });
  }

  function initEasifyLoader() {
    const loader = document.querySelector('.easify-app-loader');
    if (!loader) return;

    const appBlock = loader.closest('[data-block-type="@app"]');
    if (!appBlock) return;

    // Easify already loaded before this script ran — remove immediately.
    if (appBlock.querySelector('.tpo_option-container')) {
      loader.remove();
      return;
    }

    const timeout = setTimeout(function () {
      observer.disconnect();
      hideLoader(loader);
    }, 30000);

    const observer = new MutationObserver(function () {
      if (appBlock.querySelector('.tpo_option-container')) {
        clearTimeout(timeout);
        observer.disconnect();
        // Remove synchronously — MutationObserver fires before the next paint,
        // so this batches with Easify's render into a single frame (no layout shift).
        loader.remove();
      }
    });

    observer.observe(appBlock, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEasifyLoader);
  } else {
    initEasifyLoader();
  }
}());


/* --- Afterpay Re-render Patch ---
   Detects variant changes via the theme's product:rerender event
   and specifically refreshes only the Afterpay app blocks to avoid 
   interfering with other apps like Easify.
*/
document.addEventListener('product:rerender', (event) => {
  // Use the HTML fragment provided by the theme's core logic
  const htmlFragment = event.detail.htmlFragment;
  if (!htmlFragment) return;

  // Target all Afterpay messaging blocks specifically
  const afterpayBlocks = document.querySelectorAll('[data-block-id*="afterpay"]');
  
  afterpayBlocks.forEach((block) => {
    const blockId = block.getAttribute('data-block-id');
    // Find the new version of this specific block in the fresh HTML
    const newBlock = htmlFragment.querySelector(`[data-block-id="${blockId}"]`);
    
    if (newBlock) {
      // Replace only this specific block to refresh the Afterpay widget
      block.replaceWith(newBlock.cloneNode(true));
    }
  });
}, true); // Use capture phase to ensure we catch the event before it stops propagation
